import { createContext, useContext } from "react";

/** Opens Settings → Models & providers on its Connections tab, the one place a
    key is added or replaced. The app shell provides it (a feature may not open
    settings itself); inside that pane, the pane does, by switching its own tab.
    Null with neither — a story, a test — and the picker then leaves the action out. */
export const OpenConnections = createContext<(() => void) | null>(null);
export const useOpenConnections = () => useContext(OpenConnections);
